export const defaultUrl =
  "https://commonfiles.prisms.in/commonfiles/avatar.jpg";

export const ReplaceUrl = (val) => {
  return val.replace(
    "https://s3.amazonaws.com/topschool-attachments",
    "https://files.prisms.in"
  );
};
